(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("reselect-tree", [], factory);
	else if(typeof exports === 'object')
		exports["reselect-tree"] = factory();
	else
		root["reselect-tree"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("debug");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("source-map-support/register");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("path");

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entries = __webpack_require__(5);

var _entries2 = _interopRequireDefault(_entries);

var _assign = __webpack_require__(6);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(7);

var _keys2 = _interopRequireDefault(_keys);

exports.createNestedSelector = createNestedSelector;
exports.createLeaf = createLeaf;
exports.createSelectorTree = createSelectorTree;

var _debug = __webpack_require__(0);

var _debug2 = _interopRequireDefault(_debug);

__webpack_require__(1);

var _reselect = __webpack_require__(8);

var _jsonPointer = __webpack_require__(9);

var _jsonPointer2 = _interopRequireDefault(_jsonPointer);

var _path = __webpack_require__(2);

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const debug = (0, _debug2.default)("reselect-tree");

/**
 * Create a single memoized selector for a collection of named sub-selectors.
 * Behaves like `createStructuredSelector` but also allows direct invocation
 * of child selectors.
 *
 * For example:
 *
 *   const shop = createNestedSelector({
 *     items: (state) => state.items,
 *     promos: (state) => state.promos
 *   });
 *
 * Results in three selectors:
 *
 *   shop(state) ==> { items: state.items, promos: state.items }
 *   shop.items(state) => state.items
 *   shop.promos(state) => state.promos
 *
 * Override `rootSelector` to change behavior of top-level (i.e. `shop(state)`
 * in example.)
 *
 * @param {Object} selectors - object description of selector funcs
 * @param {Selector} rootSelector - specify root selector instead of aggregation
 * @return Selector
 */
function createNestedSelector(selectors, rootSelector = null) {
  let selector;

  if (!rootSelector) {
    // unspecified means default to structured aggregation
    selector = (0, _reselect.createStructuredSelector)(selectors);
  } else if (!(rootSelector instanceof Object) || !rootSelector.resultFunc) {
    // rootSelector isn't already a selector, or it's not an object...
    // forward to `createSelector()`
    selector = (0, _reselect.createSelector)(rootSelector);
  } else {
    // otherwise, just use as is
    selector = rootSelector;
  }

  // add properties for child selectors
  (0, _keys2.default)(selectors).forEach(prop => {
    selector[prop] = selectors[prop];
  });

  return selector;
}

class Leaf {
  constructor(deps, selector) {
    this.deps = deps;
    this.selector = selector;
  }

  contextualize(resolve, pointer) {
    let resolved = this.deps.map(dep => {
      if (typeof dep == 'string') {
        if (dep == "") {
          dep = "/";
        }

        let abspath = _path2.default.posix.resolve(pointer, "..", dep);

        return (...args) => {
          debug("args: %o", args);
          let selector = resolve(abspath);
          debug("resolved selector: %o", selector);
          let result = selector.apply(selector, args);
          debug("result: %o", result);
          return result;
        };
      }

      return dep;
    });

    return (0, _reselect.createSelector)(resolved, this.selector);
  }
}

function createLeaf(deps, selector) {
  return new Leaf(deps, selector);
}

class Tree {
  setRoot(root) {
    this.root = root;
  }

  resolve(abspath) {
    var resolved;
    try {
      let parsed = _jsonPointer2.default.parse(abspath);

      let cur = this.root;
      for (let step of parsed) {
        cur = cur[step];
      }

      return cur;
    } catch (e) {
      debug("failed, root: %O", this.root);
      throw e;
    }

    return resolved;
  }
}

function createSelectorTree(root) {
  let tree = new Tree();

  let selector = _createNode(root, tree.resolve.bind(tree), "");

  tree.setRoot(selector);

  return selector;
}

/**
 * Recursively create a selector node in the tree, applying context to nodes
 * as needed.
 */
function _createNode(node, resolve, pointer = "") {
  //based on type of node, operate differently
  if (node instanceof Leaf) {
    // base case - leaf nodes just need context resolution for relative deps
    return node.contextualize(resolve, pointer);
  } else if (node instanceof Object && !(node instanceof Function)) {
    // node is an object, recurse necessary

    const recurse = (key, child) => _createNode(child, resolve, `${pointer}/${key}`);

    let selectors = (0, _assign2.default)({}, ...(0, _entries2.default)(node).map(([key, child]) => ({ [key]: recurse(key, child) })));

    // special-case `_` child nodes override root selector
    const rootSelector = selectors._ || null;

    return createNestedSelector(selectors, rootSelector);
  } else {
    // default, just return
    return node;
  }
}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/object/entries");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/object/assign");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/object/keys");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("reselect");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("json-pointer");

/***/ })
/******/ ]);
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/reselect-tree/index.js
// module id = 1041
// module chunks = 0